<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6">
        {{ 'FOOTER_TEXT' | translate: { year: year, name: environment.appName } }}
        <a class="ms-1" target="_blank" [href]="Resources.PrivacyPolicy">{{ 'USERS.PRIVACY_POLICY' | translate }}</a>
        <a class="ms-1" target="_blank" [href]="Resources.TermsOfUse">{{ 'TERMS.TITLE' | translate }}</a>
      </div>
      <div class="col-sm-6">
        <div class="text-sm-end d-none d-sm-block">
          {{ 'FOOTER_DESIGNED' | translate: { name: environment.appName } }}
        </div>
      </div>
    </div>
  </div>
</footer>
